export const existEmail = async (email) => {
    try {
        const url = `https://backend.omnicontent.com.br/creators`;
        const response = await fetch(`${url}?query=${email}`, {
            method: "GET",
            headers: {
                Authorization: process.env.REACT_APP_TOKEN,
                "Content-Type": "application/json",
            },
        });

        const data = await response.json();

        if (Array.isArray(data) && data.length > 0 && data[0]?.id) {
            return {
                success: false,
                error: "Este e-mail já está cadastrado. Para acessar a plataforma, clique em Login!",
            };
        }

        return { success: true };
    } catch (error) {
        console.error("Erro ao validar e-mail:", error);
        return {
            success: false,
            error: "Ocorreu um erro ao validar o e-mail. Tente novamente.",
        };
    }
};

export const isValidEmailFormat = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
